<ion-content *transloco="let t" class="safe-content">
  <div class="center-container">
    <div class="desktop-back" (click)="this.modalCtrl.dismiss()"
      style="align-items: center; display: flex; padding: 16px; gap: 10px; border-bottom: 1px solid #E4E0EB;">
      <ion-icon style="font-size: 20px; color: #1E1725; cursor: pointer" name="chevron-back-outline"></ion-icon>
      <div style="width: calc(100% - 70px); color: #1E1725; padding-top: 2px;" class="body-sm-semibold">
        {{ Open === 'Open' ? t('Post Incorporation Checklist') : t('Annual Compliance') }}
      </div>
    </div>

    <ion-segment [(ngModel)]="Open" value="buttons" mode="ios">
      <ion-segment-button value="Open">
        <div [ngClass]="Open === 'Open' ? 'segment-text-active' : 'segment-text'" class="segment-text">
          {{ t('Post Incorporation Checklist') }}
        </div>
      </ion-segment-button>
      <ion-segment-button value="Open2">
        <div [ngClass]="Open === 'Open2' ? 'segment-text-active' : 'segment-text'">{{ t('Annual Compliance') }}</div>
      </ion-segment-button>
    </ion-segment>

    <table *ngIf="showNoCompany === false">


      <tbody *ngIf="Open === 'Open'">

        <!---- <tr>
          <td colspan="2">
            <div class="status-container">
              <div class="progress-bar-container">
              <div class="progress-bar" [style.width.%]="calculateProgress() * 100 / 8"></div>
              <div class="progress-text">{{ calculateProgress() }} out of 8 Tasks Completed</div>
            </div>
          </div>
          </td>
          </tr>-->
        <tr>
          <td colspan="2">
            <div style="display: flex; align-items: center;">
              <ion-icon style="width: 30px;" class="check-icon" [attr.icon-completed]="picAppointCompanySecretaryStatus"
                name="checkmark-circle"></ion-icon>
              <div style="width: calc(100% - 30px);">
                <a class="checklist-item">{{ t('Appoint Company Secretary') }}</a>
                <br>
                <span style="font-size: 10px;">{{ t('Within 30 days from incorporation date') }}</span>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div style="display: flex; align-items: center;">
              <ion-icon style="width: 30px;" class="check-icon" [attr.icon-completed]="picOpenBankAccountStatus"
                name="checkmark-circle">
              </ion-icon>
              <div style="width: calc(100% - 30px);">
                <span class="clickable-cell" (click)="banklink()">{{ t('Open Bank Account') }}</span>
                <br>
                <span style="font-size: 10px;">{{ t('After appoint company secretary') }}</span>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div style="display: flex; align-items: center;">
              <ion-icon style="width: 30px;" class="check-icon" [attr.icon-completed]="picApplyBusinessLicenseStatus"
                name="checkmark-circle"></ion-icon>
              <div style="width: calc(100% - 30px);">
                <span class="clickable-cell" (click)="businesslicenselink()">{{ t('Apply Business License') }}</span>
                <br>
                <span style="font-size: 10px;">{{ t('According to your business nature (If applicable)') }}</span>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div style="display: flex; align-items: center;">
              <ion-icon style="width: 30px;" class="check-icon" [attr.icon-completed]="picFixFinancialYearEndedStatus"
                name="checkmark-circle"></ion-icon>
              <div style="width: calc(100% - 30px);"> 
                <span class="clickable-cell" (click)="fixfy()">{{ t('Fix Financial Year End') }}</span>
                <br>
                <span style="font-size: 10px;">{{ t('Within 18 months from our company incorporation date') }}</span>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div style="display: flex; align-items: center;">
              <ion-icon style="width: 30px;" class="check-icon" [attr.icon-completed]="picAppointAuditorStatus"
                name="checkmark-circle"></ion-icon>
              <div style="width: calc(100% - 30px);">
                <span class="clickable-cell" (click)="appointauditor()">{{ t('Appoint Auditor (If Applicable)') }}</span>
                <br>
                <span style="font-size: 10px;">{{ t('Get a free resolution of appointment of auditor, if you appoint CWC & ENG PLT as your auditor') }}</span>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div style="display: flex; align-items: center;">
              <ion-icon style="width: 30px;" class="check-icon" [attr.icon-completed]="picAppointTaxAgentStatus"
                name="checkmark-circle"></ion-icon>
              <div style="width: calc(100% - 30px);"> 
                <span class="clickable-cell" (click)="appointtaxagent()">{{ t('Appoint Tax Agent') }}</span>
                <br>
                <span style="font-size: 10px;">{{ t('Get a free resolution of appointment of tax agent, if you appoint Altomate as your Tax Agent') }}</span>
              </div>


            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div style="display: flex; align-items: center;">
              <ion-icon style="width: 30px;" class="check-icon" [attr.icon-completed]="picPayrollStatus" name="checkmark-circle"></ion-icon>
              <div style="width: calc(100% - 30px);">
                <span class="clickable-cell" (click)="payroll()">{{ t('Payroll') }}</span>
                <br>
                <span style="font-size: 10px;">{{ t('Get a free resolution of appointment of tax agent, if you appoint Altomate as your Tax Agent') }}</span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>

      <tbody *ngIf="Open === 'Open2'">
        <tr *ngIf="acAnnualReturnYear2.length !== 0">
          <td style="margin-left: 10px;font-weight: bold; font-size: 14px;" colspan="2">
            {{currentYear2}}
          </td>
        </tr>
        <tr *ngFor="let year of acAnnualReturnYear2">
          <td colspan="2" *ngIf="year === currentYear2 +'C29'">
            <div style="display: flex; align-items: center;">
              <ion-icon class="check-icon" name="checkmark-circle"></ion-icon>
              <div>
                <a class="checklist-item">{{ t('Annual Return') }}</a>
                <br>
                <span style="font-size: 10px;">
                  <span *ngIf="deadlineAR!==null">{{ t('Deadline') }} : {{deadlineAR | date:'dd MMM yyyy'}}</span>
                </span>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngFor="let year of acAnnualReturnYear2">
          <td colspan="2" *ngIf="year === currentYear2 +'C31'">
            <div style="display: flex; align-items: center;">
              <ion-icon class="check-icon" name="checkmark-circle"></ion-icon>
              <div>
                <a class="checklist-item">{{ t('Audited Financial Report/Compilation Report') }}</a>
                <br>
                <span style="font-size: 10px;">

                  <span *ngIf="deadlineAFS!==null">{{ t('Deadline') }} : {{deadlineAFS | date:'dd MMM yyyy'}}</span>
                </span>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngFor="let year of acAnnualReturnYear2">
          <td colspan="2" *ngIf="year === currentYear2 +'C95'">
            <div style="display: flex; align-items: center;">
              <ion-icon class="check-icon" name="checkmark-circle"></ion-icon>
              <div>
                <a class="checklist-item">{{ t('Form E Submission') }}</a>
                <br>
                <span style="font-size: 10px;">

                  <span *ngIf="deadlineE!==null">{{ t('Deadline') }} : {{deadlineE | date:'dd MMM yyyy'}}</span>
                </span>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngFor="let year of acAnnualReturnYear2">
          <td colspan="2" *ngIf="year === currentYear2 +'C87'">
            <div style="display: flex; align-items: center;">
              <ion-icon class="check-icon" name="checkmark-circle"></ion-icon>
              <div>
                <a class="checklist-item">{{ t('Form C Filing') }}</a>
                <br>
                <span style="font-size: 10px;">

                  <span *ngIf="deadlineC!==null">{{ t('Deadline') }} : {{deadlineC | date:'dd MMM yyyy'}}</span>
                </span>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngFor="let year of acAnnualReturnYear2">
          <td colspan="2" *ngIf="year === currentYear2 +'C87'">
            <hr />
          </td>
        </tr>
        <tr *ngIf="acAnnualReturnYear1.length !== 0">
          <td style="margin-left: 10px;font-weight: bold; font-size: 14px;" colspan="2">
            {{currentYear1}}
          </td>
        </tr>
        <tr *ngFor="let year of acAnnualReturnYear1">
          <td colspan="2" *ngIf="year === currentYear1 +'C29'">
            <div style="display: flex; align-items: center;">
              <ion-icon class="check-icon" name="checkmark-circle"></ion-icon>
              <div>
                <a class="checklist-item">{{ t('Annual Return') }}</a>
                <br>
                <span style="font-size: 10px;">

                  <span *ngIf="deadlineAR!==null">{{ t('Deadline') }} : {{deadlineAR | date:'dd MMM yyyy'}}</span>
                </span>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngFor="let year of acAnnualReturnYear1">
          <td colspan="2" *ngIf="year === currentYear1 +'C31'">
            <div style="display: flex; align-items: center;">
              <ion-icon class="check-icon" name="checkmark-circle"></ion-icon>
              <div>
                <a class="checklist-item">{{ t('Audited Financial Report/Compilation Report') }}</a>
                <br>
                <span style="font-size: 10px;">

                  <span *ngIf="deadlineAFS!==null">{{ t('Deadline') }} : {{deadlineAFS | date:'dd MMM yyyy'}}</span>
                </span>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngFor="let year of acAnnualReturnYear1">
          <td colspan="2" *ngIf="year === currentYear1 +'C95'">
            <div style="display: flex; align-items: center;">
              <ion-icon class="check-icon" name="checkmark-circle"></ion-icon>
              <div>
                <a class="checklist-item">{{ t('Form E Submission') }}</a>

                <br>
                <span style="font-size: 10px;">

                  <span *ngIf="deadlineE!==null">{{ t('Deadline') }} : {{deadlineE | date:'dd MMM yyyy'}}</span>
                </span>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngFor="let year of acAnnualReturnYear1">
          <td colspan="2" *ngIf="year === currentYear1 +'C87'">
            <div style="display: flex; align-items: center;">
              <ion-icon class="check-icon" name="checkmark-circle"></ion-icon>
              <div>
                <a class="checklist-item">{{ t('Form C Filing') }}</a>
                <br>
                <span style="font-size: 10px;">
                  <span *ngIf="deadlineC!==null">{{ t('Deadline') }} : {{deadlineC | date:'dd MMM yyyy'}}</span>
                </span>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngFor="let year of acAnnualReturnYear1">
          <td colspan="2" *ngIf="year === currentYear1 +'C87'">
            <hr />
          </td>
        </tr>

        <tr *ngIf="acAnnualReturnYear.length !== 0">
          <td style="margin-left: 10px;font-weight: bold; font-size: 14px;" colspan="2">
            {{currentYear}}
          </td>
        </tr>
        <tr *ngFor="let year of acAnnualReturnYear">
          <td colspan="2" *ngIf="year === currentYear +'C29'">
            <div style="display: flex; align-items: center;">
              <ion-icon class="check-icon" [attr.icon-completed]="acAnnualReturnStatus"
                name="checkmark-circle"></ion-icon>
              <div>
                <a class="checklist-item">{{ t('Annual Return') }}</a>
                <br>
                <span style="font-size: 10px;">

                  <span *ngIf="deadlineAR!==null">{{ t('Deadline') }} : {{deadlineAR | date:'dd MMM yyyy'}}</span>
                </span>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngFor="let year of acAnnualReturnYear">
          <td colspan="2" *ngIf="year === currentYear +'C31'">
            <div style="display: flex; align-items: center;">
              <ion-icon class="check-icon" [attr.icon-completed]="acAuditedFinancialReportCompliationReportStatus"
                name="checkmark-circle"></ion-icon>
              <div>
                <a class="checklist-item">{{ t('Audited Financial Report/Compilation Report') }}</a>
                <br>
                <span style="font-size: 10px;">

                  <span *ngIf="deadlineAFS!==null">{{ t('Deadline') }} : {{deadlineAFS | date:'dd MMM yyyy'}}</span>
                </span>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngFor="let year of acAnnualReturnYear">
          <td colspan="2" *ngIf="year === currentYear +'C95'">
            <div style="display: flex; align-items: center;">
              <ion-icon class="check-icon" [attr.icon-completed]="acFormESubmissionStatus"
                name="checkmark-circle"></ion-icon>
              <div>
                <a class="checklist-item">{{ t('Form E Submission') }}</a>
                <br>
                <span style="font-size: 10px;">

                  <span *ngIf="deadlineE!==null">{{ t('Deadline') }} : {{deadlineE | date:'dd MMM yyyy'}}</span>
                </span>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngFor="let year of acAnnualReturnYear">
          <td colspan="2" *ngIf="year === currentYear +'C87'">
            <div style="display: flex; align-items: center;">
              <ion-icon class="check-icon" [attr.icon-completed]="acFormCFillingStatus"
                name="checkmark-circle"></ion-icon>
              <div>
                <a class="checklist-item">{{ t('Form C Filing') }}</a>
                <br>
                <span style="font-size: 10px;">
                  <span *ngIf="deadlineC!==null">{{ t('Deadline') }} : {{deadlineC | date:'dd MMM yyyy'}}</span>
                </span>
              </div>
            </div>
          </td>
        </tr>

      </tbody>
    </table>


  </div>
</ion-content>
